import {
  onAddOrder,
  onAyudaTour,
  onChangePage,
  onChangePerPage,
  onChangeSiteMaintenance,
  onChangeTotal,
  onDarkMode,
  onDisabledSubmitButton,
  onModalTour,
  onOpenDrawer,
  onOpenSharedModal,
  onOrderBy,
  onResetPaginate,
  onShowSkeleton,
  setIsLoading,
  setMessageLoading,
  setOpenSnackBar,
  SnackBarInterface,
} from "store";

import { useAppDispatch, useAppSelector } from "./reduxHooks";

export const useUiStore = () => {
  const dispatch = useAppDispatch();
  const {
    darkMode,
    openDrawer,
    page,
    perPage,
    total,
    isLoading,
    messageLoading,
    openSnackBar,
    messageSnackBar,
    optionsSnackBar,
    showSkeleton,
    disabledSubmitButton,
    siteUnderMaintenance,
    sharedModal,
    order,
    orderBy,
    modalTour,
    ayudaTour,
  } = useAppSelector((state) => state.ui);

  const resetPaginador = () => dispatch(onResetPaginate());
  const changePage = (value: Number) => dispatch(onChangePage(value));
  const changePerPage = (value: Number) => dispatch(onChangePerPage(value));
  const changeTotalPage = (value: Number) => dispatch(onChangeTotal(value));
  const handleOpenDrawer = (value: boolean) => dispatch(onOpenDrawer(value));
  const handleChangeDarkMode = (value: "light" | "dark") =>
    dispatch(onDarkMode(value));
  const loadingBackdrop = (status: boolean) => dispatch(setIsLoading(status));
  const addMessageSnackBmessageSnackBar = (message: string) =>
    dispatch(setMessageLoading(message));
  const showSkeletonAnimation = (status: boolean) =>
    dispatch(onShowSkeleton(status));
  const openSnackBarMessage = (args: {
    status: boolean;
    message: string;
    optionsSnackBar: SnackBarInterface;
  }) => dispatch(setOpenSnackBar(args));
  const changeDisabledSubmitButton = (status: boolean) =>
    dispatch(onDisabledSubmitButton(status));
  const changeSiteMaintenance = (status: boolean) =>
    dispatch(onChangeSiteMaintenance(status));
  const openSharedModal = (status: boolean) =>
    dispatch(onOpenSharedModal(status));
  const addOrderTableHead = (order:"desc"| "asc") => dispatch(onAddOrder(order));
  const addRowSelected = (row:string)=>dispatch(onOrderBy(row))
  const handleModalTour = (value: boolean) => dispatch(onModalTour(value));
  const handleAyudaTour = (value: boolean) => dispatch(onAyudaTour(value));
  return {
    /**Propiedades */
    page,
    total,
    perPage,
    openDrawer,
    darkMode,
    isLoading,
    messageLoading,
    openSnackBar,
    messageSnackBar,
    optionsSnackBar,
    showSkeleton,
    disabledSubmitButton,
    siteUnderMaintenance,
    sharedModal,
    order,
    orderBy,
    modalTour,
    ayudaTour,
    /**Métodos */
    changePage,
    changePerPage,
    resetPaginador,
    changeTotalPage,
    handleOpenDrawer,
    handleChangeDarkMode,
    loadingBackdrop,
    addMessageSnackBmessageSnackBar,
    openSnackBarMessage,
    showSkeletonAnimation,
    changeDisabledSubmitButton,
    changeSiteMaintenance,
    openSharedModal,
    addOrderTableHead,
    addRowSelected,
    handleModalTour,
    handleAyudaTour,
  };
};
